


































import Vue from "vue";
import debounce from "lodash/debounce";
import type { DebouncedFunc } from "lodash";
import SearchIcon from "@/icons/Search.vue";

export default Vue.extend({
  name: "SearchInput",
  components: {
    SearchIcon
  },
  props: {
    autocapitalize: { type: String, default: "none" },
    autocomplete: { type: String, default: "" },
    autofocus: { type: Boolean, default: false },
    dataCy: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
    list: { type: String, default: null },
    maxlength: { type: Number, default: 524288 },
    placeholder: { type: String, default: "Search..." },
    required: { type: Boolean, default: false },
    size: { type: Number, default: 20 },
    type: { type: String, default: "search" },
    value: { type: String, default: "" }
  },
  data() {
    return {
      inputValue: this.value,
      isFocused: false
    };
  },
  computed: {
    debouncedOnInput(): DebouncedFunc<() => void> {
      return debounce(() => this.onInput(), 100);
    }
  },
  watch: {
    value(newValue: string) {
      this.inputValue = newValue;
    }
  },
  methods: {
    focus(): void {
      (this.$refs.input as HTMLInputElement).focus();
    },
    focusOnTextInput(): void {
      return this.focus();
    },
    onBlur(event: Event): void {
      this.isFocused = false;
      this.$emit("blur", event);
    },
    onChange(): void {
      this.$emit("change", this.inputValue);
    },
    onFocus(event: Event): void {
      this.isFocused = true;
      this.$emit("focus", event);
    },
    onInput() {
      this.$emit("input", this.inputValue);
    },
    onKeyDown(event: Event): void {
      this.$emit("keydown", event);
    },
    onKeyUp(event: Event): void {
      this.$emit("keyup", event);
    },
    onKeyPress(event: Event): void {
      this.$emit("keypress", event);
    },
    getScrollParent(node: Element | null): Element | null {
      if (!node) {
        return null;
      }

      if (node.scrollHeight > node.clientHeight) {
        return node;
      } else {
        return this.getScrollParent(node.parentElement);
      }
    }
  }
});
